export const successModalProccessor = (isMobile = false) => {
  const {
    auth_successModalTitleMobile = '',
    auth_successModalTitleDesk = '',
    auth_successModalDescMobile = '',
    auth_successModalDescDesk = '',
    auth_successModalDownloadAppCTA = '',
    auth_successModalStartWatchingCTA = '',
  } = window.Language;

  const headline = isMobile ? auth_successModalTitleMobile : auth_successModalTitleDesk;
  const description = isMobile ? auth_successModalDescMobile : auth_successModalDescDesk;
  const watchCTA = auth_successModalStartWatchingCTA;
  const downloadAppCTA = auth_successModalDownloadAppCTA;

  return {
    headline,
    description,
    watchCTA,
    downloadAppCTA,
  };
};

export const openApp = (regCode = '') =>
  window.location.assign(`https://foxnation.onelink.me/CbbD/InstallApp${regCode}`);
